import { Receipt } from '@mui/icons-material';
import { InvoiceBillingManager } from '../modules/invoice-billing/InvoiceBillingManager';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const InvoiceBilling: RouteType = {
  exact: true,
  path: routePaths.invoiceBilling,
  title: 'Invoice Billing',
  icon: Receipt,
  component: () => <InvoiceBillingManager />,
  permission: 'canManageInvoiceBilling',
};

export default InvoiceBilling;
